import React from "react";

import styles from "./FeedbackIntro.module.scss";

import Button from "../../../../components/Button";

export const FeedbackIntroCTA = ({ next }) => {
  return (
    <div className={styles.ctaContainerWrapper}>
      <div className={styles.ctaContainer}>
        <Button color="primary" variant="contained" fullWidth onClick={next}>
          Let's get Started
        </Button>
      </div>
    </div>
  );
};
